import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import { navigationRef } from './root.navigation.js';

import { BottomNavigation, BottomNavigationTab, Layout, Text, Icon, IconElement } from '@ui-kitten/components';
import {HomeScreen} from './src/screens/home-screen'
import {IPEVOScreen} from './src/screens/home-screen/ipevo.js'
import {VEIKKScreen} from './src/screens/home-screen/digitalpen.js'
import {MiniPCScreen} from './src/screens/home-screen/minipc.js'
import {DocamScreen} from './src/screens/home-screen/docam'
import {A30Screen} from './src/screens/home-screen/A30'
import {A50Screen} from './src/screens/home-screen/A50'
import {V2200Screen} from './src/screens/home-screen/2200'
import {V4KScreen} from './src/screens/home-screen/v4k'
import {VZXScreen} from './src/screens/home-screen/vzx'
import {ProfileScreen} from './src/screens/profile-screen'
import {ProductsScreen} from './src/screens/products-screen'
import {AboutScreen} from './src/screens/about-screen'
import {LoginScreen} from './src/screens/login-screen'
const { Navigator, Screen } = createBottomTabNavigator();
const Stack = createStackNavigator();

const PersonIcon = (props) => (
  <Icon {...props} name='person'/>
);


const MessageIcon = (props) => (
  <Icon {...props} name='message-square'/>
);

const AddIcon = (props) => (
  <Icon {...props} name='file-add'/>
);
const HomeIcon = (props)  => (
  <Icon {...props} name='grid'/>
);



const BottomTabBar = ({ navigation, state }) => (
  <BottomNavigation
  tabBarVisible={false}
    selectedIndex={state.index}
    onSelect={index => navigation.navigate(state.routeNames[index])}>
    <BottomNavigationTab title='محصولات' icon={HomeIcon} />
    <BottomNavigationTab title='ثبت نام' icon={AddIcon}/>
  </BottomNavigation>
);
// const HomeScreen = () => (
//   <Layout style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
//     <Text category='h1'>USERS</Text>
//   </Layout>
// );
// const ProductsScreen = () => (
//   <Layout style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
//     <Text category='h1'>USERS</Text>
//   </Layout>
// );
// const AbScreen = () => (
//   <Layout style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
//     <Text category='h1'>USERS</Text>
//   </Layout>
// );
// const UsersScreen = () => (
//   <Layout style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
//     <Text category='h1'>USERS</Text>
//   </Layout>
// );

const TabNavigator = () => (
  <Navigator screenOptions={{ headerShown: false }} tabBar={props => <BottomTabBar {...props} />}>
    <Screen name='home' component={HomeScreen}/>
    <Screen name='invoice' component={ProductsScreen}/>

  </Navigator>
);

export const AppNavigator = () => (
  <NavigationContainer ref={navigationRef}>
    <Stack.Navigator initialRouteName="Menu" screenOptions={{headerShown: false, initialRouteName:'Home' }}>
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="Menu" component={TabNavigator} />
      <Stack.Screen name="docam" component={DocamScreen} />
      <Stack.Screen name="a30" component={A30Screen} />
      <Stack.Screen name="a50" component={A50Screen} />
      <Stack.Screen name="v2200" component={V2200Screen} />
      <Stack.Screen name="vzx" component={VZXScreen} />
      <Stack.Screen name="v4k" component={V4KScreen} />
      <Stack.Screen name="ipevo" component={IPEVOScreen} />
      <Stack.Screen name="minipc" component={MiniPCScreen} />
      <Stack.Screen name="veikk" component={VEIKKScreen} />

    </Stack.Navigator>
  </NavigationContainer>
);
//
// export const AppNavigator = () => (
//   <NavigationContainer>
//     <TabNavigator/>
//   </NavigationContainer>
// );
